import { ScrollReveal } from '@/components/effects/ScrollReveal';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';

export const faqs = [
  {
    q: 'What is Active Training Track?',
    a: 'Active Training Track is our expert-led delivery format. Every session is delivered in real-time by industry practitioners using real tools and virtual lab environments. All sessions delivered face to face or online — your preference. One to one or small group. Flexible scheduling around your commitments. You learn by doing, not watching.',
  },
  {
    q: 'How does the free security scan work?',
    a: 'Our passive scanner analyses your domain using industry-standard tools like Mozilla HTTP Observatory and SSL Labs. It checks TLS certificates, security headers, open ports, and known vulnerabilities — all without touching your servers. Results are delivered instantly with an AI-generated summary.',
  },
  {
    q: 'What does Acodia Watch include?',
    a: 'Acodia Watch is our continuous security monitoring service starting from £49/month. It includes weekly deep scans using tools like Probely, a weekly security intelligence briefing, real-time email alerts, and a dedicated Client Pulse Dashboard showing domain health, threat timelines, and CVE tracking.',
  },
  {
    q: 'Is Acodia suitable for small businesses?',
    a: 'Absolutely. Acodia was built specifically for SMEs who need expert-level services without enterprise pricing. Whether you need security monitoring, staff training, career placement, or digital growth — our services are designed to deliver maximum impact within realistic budgets.',
  },
  {
    q: 'Where is Acodia based?',
    a: 'Acodia is a specialist practice based in London N1, registered with Companies House and the ICO. While we serve clients across the UK and internationally, our operations are rooted in London with a security-first approach to everything we do.',
  },
  {
    q: 'Can I cancel Acodia Watch at any time?',
    a: 'Yes. Acodia Watch is a monthly subscription with no long-term commitment. You can cancel at any time through the Client Pulse Dashboard or by contacting our team. We offer a 7-day free trial so you can evaluate the service risk-free.',
  },
];

export const FAQSection = () => {
  return (
    <section
      data-testid="faq-section"
      className="py-14 sm:py-20"
      style={{ background: 'var(--l2)' }}
    >
      <div className="max-w-[800px] mx-auto px-4 sm:px-6 lg:px-8">
        <ScrollReveal>
          <div className="text-center mb-12">
            <p className="font-body text-xs uppercase tracking-[0.22em] mb-3" style={{ color: 'var(--a)' }}>
              FAQ
            </p>
            <h2
              className="font-display font-extrabold tracking-[-0.03em] mb-4"
              style={{ fontSize: 'clamp(2rem, 4.5vw, 3.8rem)', color: 'var(--white)' }}
            >
              Common questions.
            </h2>
          </div>
        </ScrollReveal>

        <ScrollReveal delay={0.1}>
          <Accordion
            type="single"
            collapsible
            data-testid="faq-accordion"
            className="space-y-2"
          >
            {faqs.map((faq, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                className="rounded-lg px-5 transition-colors duration-200"
                style={{
                  background: 'rgba(10,10,18,0.88)',
                  border: '1px solid var(--b1)',
                }}
              >
                <AccordionTrigger
                  className="font-display text-sm font-semibold py-5 hover:no-underline"
                  style={{ color: 'var(--white)' }}
                >
                  {faq.q}
                </AccordionTrigger>
                <AccordionContent
                  className="font-body text-sm font-light pb-5"
                  style={{ color: 'var(--tm)', lineHeight: '1.72' }}
                >
                  {faq.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </ScrollReveal>
      </div>
    </section>
  );
};
